import { IWebhook, IWebhookFilters, IWebhookRequestParam, IWebhookValidation } from '../types/webhooks';
import { API_METHOD, defaultValidation, LOCALES, SORTING_DIRECTION } from '~/constants/main';
import { randomFloatNumber } from '~/utils/helpers';

export enum WebhookColumnName {
  NAME = 'name',
  METHOD = 'method',
  URL = 'url',
  COUNTER = 'count',
}

export const defaultWebhookFilters: IWebhookFilters = {
  sortField: WebhookColumnName.NAME,
  sortDir: SORTING_DIRECTION.ASCENDING,
};

export const defaultWebhookParam = (): IWebhookRequestParam => {
  return {
    id: 0,
    frontId: randomFloatNumber(),
    key: '',
    value: '',
  };
};

export const defaultWebhook: IWebhook = {
  id: 0,
  name: '',
  language: LOCALES.EN,
  url: '',
  type: 'order_status',
  method: API_METHOD.POST,
  headers: [defaultWebhookParam()],
  parameters: [defaultWebhookParam()],
  statuses: [],
  counter: 0,
  status: 1,
};

export const defaultWebhookValidation: IWebhookValidation = {
  isValid: true,
  name: defaultValidation,
  url: defaultValidation,
  headers: [],
  parameters: [],
  statuses: defaultValidation,
};
